/**
 * Product Page JS - Carolyn Fabrics
 * Handles: variant image swapping, thumbnail gallery, quantity stepper, AJAX cart
 */

document.addEventListener('DOMContentLoaded', function () {

  /* R5: format a raw color option value ("SCL 001 Admiral") for DISPLAY as
     "Admiral \u00B7 SCL 001" (name first). The underlying Shopify variant value
     is never touched — this only affects the visible selected-value chip.
     Returns the raw string unchanged when no leading code is detected. */
  function cfFormatColorLabel(raw) {
    if (raw == null) return '';
    var v = String(raw).trim();
    var m = v.match(/^([A-Za-z]{0,4}\s?\d{2,5})\s+(.+)$/);
    if (m && m[2]) { return m[2].trim() + ' \u00B7 ' + m[1].trim(); }
    return v;
  }

  /* ----------------------------------------------------------------
     Spec jump link — flash the Product Details section on click
  ---------------------------------------------------------------- */
  (function(){
    var jump = document.querySelector('.cf-spec-jump');
    var target = document.getElementById('product-details');
    if (!jump || !target) return;
    jump.addEventListener('click', function(){
      target.classList.remove('cf-spec-flash');
      void target.offsetWidth;
      target.classList.add('cf-spec-flash');
    });
  })();

  /* ----------------------------------------------------------------
     Thread Swatch Color Initialization
     Reads thread-color-map JSON and applies --swatch-color CSS var
  ---------------------------------------------------------------- */
  (function() {
    var mapEl = document.getElementById('thread-color-map');
    if (!mapEl) return;
    var colorMap = {};
    try { colorMap = JSON.parse(mapEl.textContent); } catch(e) { return; }

    document.querySelectorAll('[data-thread-color-name]').forEach(function(swatch) {
      var name = swatch.dataset.threadColorName;
      // Strip SKU suffix like ' (7003U)' from variant titles
      var lookupName = name.replace(/\s*\([^)]+\)$/, '').trim();
      var hex = colorMap[lookupName] || colorMap[name];
      if (hex) {
        swatch.style.setProperty('--swatch-color', hex);
        swatch.style.background = hex;
        // Light colors get a subtle border so they're visible
        var r = parseInt(hex.slice(1,3),16), g = parseInt(hex.slice(3,5),16), b = parseInt(hex.slice(5,7),16);
        if (r > 200 && g > 200 && b > 200) {
          swatch.style.border = '1px solid #555';
        }
      }
    });
  })();

  /* ----------------------------------------------------------------
     Color Swatch Search / Filter  (audit #1)
     Search box above large color palettes; hides swatches whose
     color name does not match the typed query. Typing a broad color
     word (e.g. "red", "blue") also pulls that whole visual family
     via the CF_COLOR_FAMILIES map below, since CF color names rarely
     contain the family word (Burgundy, Cinnabar, Tomato = "red").
  ---------------------------------------------------------------- */
  var CF_COLOR_FAMILIES = {
    red:['red','burgundy','cinnabar','tomato','paprika','claret','cherry','rust','oxblood','sangria','crimson','ruby','wine','scarlet','brick','garnet','maroon','poppy','american beauty','currant','magma','black cherry','china red','red rock','matador','beet','ruby'],
    orange:['orange','marmalade','amber','tangerine','pumpkin','terra cotta','terracotta','tiger lily','mandarin','copper','apricot','cinnamon','spice','rust','paprika','nugget','cortez','gingersnap','pumpkin'],
    yellow:['yellow','gold','golden','maize','sunflower','corn','mustard','curry','ochre','citron','citronella','honey','butter','lemon','saffron','banana','sun yellow','golden corn','limon','butterscotch','chutney'],
    green:['green','olive','sage','forest','hunter','emerald','moss','fern','pine','jade','seagrass','seaglass','sea glass','spruce','cypress','artichoke','yew','peapod','willow','avocado','lime','kelly','palm','eden','grotto'],
    blue:['blue','navy','capri','marine','royal','fjord','wedgewood','cobalt','sky','ocean','denim','indigo','sapphire','azure','peacock','atlantic','poseidon','meridian','regimental','space blue','imperial blue','dutch blue','blueberry','mediterranean','pacific','blue ridge','antique blue','teal','turquoise','aqua'],
    purple:['purple','violet','plum','aubergine','mauve','lavender','eggplant','grape','orchid','amethyst','concord','crocus','wood violet','deep violet','honesty'],
    pink:['pink','rose','blush','fuchsia','magenta','coral','salmon','raspberry','rosa','tea rose','rosalee','mauve'],
    brown:['brown','chestnut','mocha','espresso','coffee','saddle','chocolate','walnut','nutmeg','cognac','camel','tobacco','sable','caramel','hazel','bronze','cinnamon','pecan','beaver','oak','chaps','baja','mudslide','cordovan','buckskin','otter','cafe','mahogany','pumpernickel','outback','bay brown','olive brown','british tan','rustic'],
    tan:['tan','beige','sand','sandstone','khaki','camel','buff','oatmeal','bone','bisque','putty','doe','parchment','wheat','biscuit','fawn','ecru','stone','taupe','greige','antelope','chaps','adobe','alabaster','devon','stardust','first light'],
    grey:['grey','gray','charcoal','graphite','slate','pewter','ash','silver','gunmetal','storm','shark','steel','concrete','pavement','fog','rhino','smoke','dove','greystone','cloudy sky','pearl grey','iron','nightfall'],
    black:['black','onyx','caviar','jet','ebony','coal','noir'],
    white:['white','ivory','cream','creme','snow','snowflake','alabaster','bone','pearl','chalk','eggshell','vanilla','parchment','bisque','soft white','bright white','stardust','adobe white','chiffon']
  };
  CF_COLOR_FAMILIES.gray = CF_COLOR_FAMILIES.grey;
  CF_COLOR_FAMILIES.beige = CF_COLOR_FAMILIES.tan;
  document.querySelectorAll('.product-option[data-option-name="color"]').forEach(function(optBlock){
    var input = optBlock.querySelector('.cf-swatch-filter');
    if (!input) return;
    var countEl = optBlock.querySelector('.cf-swatch-count');
    var noRes = optBlock.querySelector('.cf-swatch-noresults');
    var swatches = Array.prototype.slice.call(optBlock.querySelectorAll('.option-value'));
    var total = swatches.length;
    function labelOf(el){
      var l = el.getAttribute('data-swatch-label');
      if (!l) { var s = el.querySelector('.option-value__label'); l = s ? s.textContent : ''; }
      return (l || '').toLowerCase();
    }
    function matchLabel(label, q){
      if (!q) return true;
      if (label.indexOf(q) !== -1) return true;
      var fam = CF_COLOR_FAMILIES[q];
      if (fam){ for (var i = 0; i < fam.length; i++){ if (label.indexOf(fam[i]) !== -1) return true; } }
      return false;
    }
    function apply(){
      var q = input.value.trim().toLowerCase();
      var shown = 0;
      swatches.forEach(function(sw){
        var match = matchLabel(labelOf(sw), q);
        sw.classList.toggle('option-value--filter-hidden', !match);
        if (match) shown++;
      });
      if (countEl) countEl.textContent = q ? (shown + ' of ' + total) : (total + ' colors');
      if (noRes) { if (!shown && !noRes.textContent) noRes.textContent = 'No colors match. Try a shorter search.'; noRes.style.display = shown ? 'none' : 'block'; }
    }
    input.addEventListener('input', apply);
    apply();
  });

  /* ----------------------------------------------------------------
     Parse variant data
  ---------------------------------------------------------------- */
  const variantDataEl = document.querySelector('#product-variants-json');
  const variantData = variantDataEl ? JSON.parse(variantDataEl.textContent) : [];

  /* ----------------------------------------------------------------
     Thumbnail Gallery
  ---------------------------------------------------------------- */
  const mainImg   = document.querySelector('#product-main-image');
  const thumbBtns = document.querySelectorAll('.product-thumb');

  thumbBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const src = btn.dataset.imageSrc;
      const alt = btn.dataset.imageAlt || '';
      if (mainImg && src) {
        mainImg.src = src;
        mainImg.alt = alt;
      }
      thumbBtns.forEach(function (b) { b.classList.remove('product-thumb--active'); });
      btn.classList.add('product-thumb--active');
    });
  });

  /* ----------------------------------------------------------------
     Quantity Stepper
  ---------------------------------------------------------------- */
  const qtyInput  = document.querySelector('.qty-input');
  const qtyDecBtn = document.querySelector('[data-qty-minus]');
  const qtyIncBtn = document.querySelector('[data-qty-plus]');

  if (qtyInput && qtyDecBtn && qtyIncBtn) {
    qtyDecBtn.addEventListener('click', function () {
      const val = parseInt(qtyInput.value, 10) || 1;
      const min = parseInt(qtyInput.min, 10) || 1;
      if (val > min) qtyInput.value = val - 1;
    });
    qtyIncBtn.addEventListener('click', function () {
      const val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
    });
    qtyInput.addEventListener('change', function () {
      const val = parseInt(qtyInput.value, 10);
      const min = parseInt(qtyInput.min, 10) || 1;
      if (isNaN(val) || val < min) qtyInput.value = min;
    });
  }

  /* ----------------------------------------------------------------
     Variant Selection + Image Swap
  ---------------------------------------------------------------- */
  const variantIdInput = document.querySelector('#product-variant-id');
  const priceEl        = document.querySelector('.product-price-wrap [data-product-price]');
  const selectedLabels = document.querySelectorAll('[id^="option-selected-"]');
  const skuEl          = document.querySelector('#product-sku');

  const originalMainDisplay = mainImg ? mainImg.style.display : '';
  const originalThumbDisplays = Array.from(thumbBtns, function (btn) { return btn.style.display; });

  function swapMainImage(variant) {
    if (!variant || !mainImg) return;
    // This color has no verified photograph; do not show another color as Red.
    var photoMissing = Number(variant.id) === 46099091259580 && !variant.featured_image;
    var photoNotice = document.getElementById('cf-color-photo-unavailable');
    if (photoMissing && !photoNotice) {
      photoNotice = document.createElement('p');
      photoNotice.id = 'cf-color-photo-unavailable';
      photoNotice.setAttribute('role', 'status');
      photoNotice.textContent = 'Photo unavailable for Red. Contact us to confirm the color before ordering.';
      mainImg.parentNode.insertBefore(photoNotice, mainImg);
    }
    if (photoNotice) photoNotice.hidden = !photoMissing;
    mainImg.hidden = photoMissing;
    mainImg.style.display = photoMissing ? 'none' : originalMainDisplay;
    thumbBtns.forEach(function (btn, index) {
      btn.hidden = photoMissing;
      btn.style.display = photoMissing ? 'none' : originalThumbDisplays[index];
    });
    if (photoMissing || !variant.featured_image) return;
    const img = variant.featured_image;
    // Build URL from Shopify image src
    const src = img.src.replace(/(\.\w+)(\?.*)?$/, '_800x$1');
    mainImg.src = src;
    mainImg.alt = img.alt || variant.title || '';

    // Also update active thumb if we can match it
    thumbBtns.forEach(function (btn) {
      btn.classList.remove('product-thumb--active');
      if (btn.dataset.imageSrc && btn.dataset.imageSrc.includes(img.src.split('?')[0].split('/').pop().replace(/(\.\w+)$/, ''))) {
        btn.classList.add('product-thumb--active');
      }
    });
  }

  function findMatchingVariant() {
    const selectedOptions = [];
    document.querySelectorAll('.product-option').forEach(function (group) {
      const checked = group.querySelector('input[type="radio"]:checked');
      if (checked) selectedOptions.push(checked.value);
    });
    return variantData.find(function (v) {
      return selectedOptions.every(function (opt, i) {
        return v['option' + (i + 1)] === opt;
      });
    });
  }

  document.querySelectorAll('.product-option__values label').forEach(function (label) {
    label.addEventListener('click', function () {
      const radio = label.querySelector('input[type="radio"]');
      if (!radio) return;
      radio.checked = true;

      // Update selected highlight
      const parent = label.closest('.product-option__values');
      if (parent) {
        parent.querySelectorAll('.option-value').forEach(function (l) {
          l.classList.remove('option-value--selected');
        });
        label.classList.add('option-value--selected');
      }

      // Update inline "selected value" label
      const optionIndex = radio.dataset.optionIndex;
      const selLabel = optionIndex !== undefined ? document.getElementById('option-selected-' + optionIndex) : null;
      if (selLabel) {
        selLabel.setAttribute('data-raw', radio.value);
        selLabel.textContent = cfFormatColorLabel(radio.value);
      }

      const matched = findMatchingVariant();
      if (matched) {
        if (variantIdInput) variantIdInput.value = matched.id;
        if (priceEl) { const unit = priceEl.querySelector('.price-unit'); priceEl.textContent = '$' + (matched.price / 100).toFixed(2); if (unit) priceEl.appendChild(unit); }
        if (skuEl && matched.sku) skuEl.textContent = matched.sku;
        swapMainImage(matched);
        const url = new URL(window.location);
        url.searchParams.set('variant', matched.id);
        history.replaceState(null, '', url);
      }
    });
  });

  // On page load - swap to first available variant image
  (function () {
    const requestedId = new URL(window.location.href).searchParams.get('variant') || (variantIdInput && variantIdInput.value);
    const firstVariant = variantData.find(function (v) { return String(v.id) === String(requestedId); }) || variantData.find(function (v) { return v.available; }) || variantData[0];
    if (firstVariant) swapMainImage(firstVariant);
  })();

  /* ----------------------------------------------------------------
     AJAX Add to Cart
  ---------------------------------------------------------------- */
  const addToCartForm = document.querySelector('#product-form');
  const addToCartBtn  = document.querySelector('.product-add-btn');

  if (addToCartForm && addToCartBtn) {
    addToCartForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const variantId = variantIdInput ? variantIdInput.value : null;
      if (!variantId) return;

      const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      const properties = {};
      addToCartForm.querySelectorAll('[name^="properties["]').forEach(function (input) {
        const match = input.name.match(/^properties\[(.+)\]$/);
        if (match && input.value) properties[match[1]] = input.value;
      });

      setButtonLoading(true);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity, properties: properties })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Error'); });
          return res.json();
        })
        .then(function (addedLine) {
          if (window.CFAnalytics && typeof window.CFAnalytics.trackOutdoorAddToCart === 'function') {
            window.CFAnalytics.trackOutdoorAddToCart(addedLine, quantity);
          }
          setButtonSuccess();
          updateCartCount();
          if (window.CF && window.CF.openCartDrawer) {
            setTimeout(window.CF.openCartDrawer, 400);
          }
        })
        .catch(function (err) {
          setButtonLoading(false);
          console.error('Add to cart error:', err.message);
        });
    });

    // Hydration guard: button ships disabled in HTML; enable it now that the AJAX
    // submit handler is attached, so a fast first click can't slip through as a
    // native (no-op) form submit. (3s inline fallback in the template fails open.)
    if (addToCartBtn.hasAttribute('data-add-hydrate')) addToCartBtn.disabled = false;
  }

  function setButtonLoading(isLoading) {
    if (!addToCartBtn) return;
    addToCartBtn.disabled = isLoading;
    if (isLoading) {
      addToCartBtn.dataset.originalText = addToCartBtn.textContent;
      addToCartBtn.textContent = 'Adding...';
    } else {
      addToCartBtn.textContent = addToCartBtn.dataset.originalText || 'Add to Cart';
    }
  }

  function setButtonSuccess() {
    if (!addToCartBtn) return;
    addToCartBtn.disabled = false;
    addToCartBtn.textContent = 'Added to Cart';
    addToCartBtn.style.backgroundColor = '#2d6a3f';
    addToCartBtn.style.borderColor = '#2d6a3f';
    setTimeout(function () {
      addToCartBtn.textContent = addToCartBtn.dataset.originalText || 'Add to Cart';
      addToCartBtn.style.backgroundColor = '';
      addToCartBtn.style.borderColor = '';
    }, 2000);
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = document.querySelector('.cart-icon__count');
        if (count) count.textContent = cart.item_count;
      })
      .catch(function () {});
  }

  /* ----------------------------------------------------------------
     Sample Swatch Button
  ---------------------------------------------------------------- */
  const sampleBtn = document.querySelector('[data-sample-btn]');
  if (sampleBtn) {
    sampleBtn.addEventListener('click', function () {
      const sampleVariantId = sampleBtn.dataset.sampleVariantId;
      if (!sampleVariantId) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: sampleVariantId, quantity: 1, properties: (function(){ var p={}; var t=sampleBtn.dataset.productTitle; var c=document.querySelector('[data-option-name="color"] input[type="radio"]:checked'); var img=document.getElementById('product-main-image'); if(t) p['Material']=t; if(c) p['Color']=c.value.replace(/\s*\([^)]+\)$/,'').trim(); if(img&&!img.hidden&&img.src) p['_img']=img.src; return p; })() })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          sampleBtn.textContent = 'Sample Added!';
          updateCartCount();
          setTimeout(function () {
            sampleBtn.textContent = 'Order a $5 sample';
          }, 2000);
        })
        .catch(function () {});
    });
  }

});
/* ================================================================
   THREAD MATCH - shows suggested thread colors on product pages
   Fires when a Color swatch is selected. Strips SKU prefixes.
   ================================================================ */
(function() {
  var MAP = {
    "white":["Nat. White","Creme","Pearl Grey"],"bright white":["Nat. White","Creme","Pearl Grey"],
    "brilliant white":["Nat. White","Creme","Pearl Grey"],"pure white":["Nat. White","Creme","Pearl Grey"],
    "off white":["Nat. White","Creme","Sandstone"],"ivory":["Nat. White","Creme","Sand"],
    "cream":["Creme","Nat. White","Sand"],"creme":["Creme","Nat. White","Sand"],
    "chalk":["Nat. White","Creme","Pearl Grey"],"snow":["Nat. White","Pearl Grey","Creme"],
    "porcelain":["Nat. White","Creme","Pearl Grey"],"moonbeam":["Nat. White","Pearl Grey","Cloudy Sky"],
    "whitecap":["Nat. White","Creme","Pearl Grey"],"white cap":["Nat. White","Creme","Pearl Grey"],
    "glacier":["Nat. White","Pearl Grey","Cloudy Sky"],"milkweed":["Nat. White","Creme","Sand"],
    "alabaster":["Nat. White","Creme","Sand"],"adobe white":["Nat. White","Creme","Sand"],
    "marshmallow":["Nat. White","Creme","Pearl Grey"],"warm white":["Nat. White","Creme","Sand"],
    "pearl white":["Nat. White","Pearl Grey","Creme"],"pearl":["Nat. White","Pearl Grey","Creme"],
    "iceberg":["Nat. White","Pearl Grey","Cloudy Sky"],"albatross":["Nat. White","Creme","Pearl Grey"],
    "salt":["Nat. White","Pearl Grey","Creme"],"shell":["Nat. White","Creme","Sand"],
    "hail":["Nat. White","Pearl Grey","Cloudy Sky"],"ice":["Nat. White","Pearl Grey","Cloudy Sky"],
    "cotton":["Nat. White","Creme","Pearl Grey"],"sheer":["Nat. White","Creme","Pearl Grey"],
    "vellum":["Nat. White","Creme","Sand"],"flax":["Creme","Sand","Sandstone"],
    "oatmeal":["Creme","Sand","Sandstone"],"linen":["Creme","Sand","Nat. White"],
    "ecru":["Creme","Sand","Nat. White"],"vanilla":["Creme","Nat. White","Sand"],
    "french vanilla":["Creme","Nat. White","Sand"],    "tan":["Sand","Sandstone","Saddle"],"sand":["Sand","Sandstone","Nat. White"],
    "sand dollar":["Sand","Sandstone","Nat. White"],"dune":["Sand","Sandstone","Saddle"],
    "parchment":["Sand","Sandstone","Nat. White"],"bisque":["Sand","Creme","Sandstone"],
    "bone":["Creme","Sand","Nat. White"],"putty":["Sandstone","Sand","Storm Grey"],
    "camel":["Sandstone","Sand","Saddle"],"antelope":["Sandstone","Sand","Saddle"],
    "buff":["Sand","Sandstone","Creme"],"taupe":["Sandstone","Storm Grey","Sand"],
    "khaki":["Sand","Sandstone","Olive Brown"],"wheat":["Sand","Sandstone","Creme"],
    "canvas":["Sand","Sandstone","Creme"],"beige":["Sand","Sandstone","Creme"],
    "champagne":["Sandstone","Sand","Creme"],"farro":["Sand","Sandstone","Creme"],
    "empire tan":["Sandstone","Sand","Saddle"],"lt. sand":["Sand","Sandstone","Creme"],
    "lt. parchment":["Sand","Nat. White","Creme"],"lt neutral":["Sand","Nat. White","Creme"],
    "med neutral":["Sandstone","Sand","Storm Grey"],"med beige":["Sandstone","Sand","Saddle"],
    "neutral":["Sand","Sandstone","Creme"],"neutra":["Sand","Sandstone","Creme"],
    "buttercream":["Creme","Sand","Nat. White"],"straw":["Sand","Sandstone","Creme"],
    "tofu":["Creme","Sand","Nat. White"],"barley":["Sand","Sandstone","Creme"],
    "sisal":["Sand","Sandstone","Olive Brown"],"oyster":["Creme","Sand","Nat. White"],
    "cashmere":["Creme","Sand","Sandstone"],"sugar":["Nat. White","Creme","Sand"],
    "titan neutral":["Sand","Sandstone","Nat. White"],"raffia":["Sand","Sandstone","Olive Brown"],
    "hemp":["Sand","Olive Brown","Sandstone"],"burlap":["Sandstone","Olive Brown","Sand"],
    "prairie tan":["Sand","Sandstone","Saddle"],"med. prairie tan":["Sand","Sandstone","Saddle"],
    "spicy":["Ochre","Sandstone","Sand"],"sundance":["Sunflower Gold","Ochre","Sand"],
    "sunglow":["Sunflower Gold","Ochre","Sand"],"gold":["Ochre","Sunflower Gold","Sand"],
    "golden corn":["Sunflower Gold","Ochre","Sand"],"marigold":["Sunflower Gold","Ochre","Orange"],
    "ochre":["Ochre","Sunflower Gold","Sand"],"honey":["Ochre","Sunflower Gold","Sand"],
    "amber":["Ochre","Sunflower Gold","Sandstone"],"brass":["Ochre","Sunflower Gold","Sand"],
    "nugget":["Ochre","Sunflower Gold","Sand"],"butterscotch":["Ochre","Sunflower Gold","Sand"],
    "mustard":["Ochre","Sunflower Gold","Sand"],"yellow":["Sunflower Gold","Ochre","Sand"],
    "sunshine":["Sunflower Gold","Ochre","Sand"],"saffron":["Ochre","Sunflower Gold","Sand"],
    "citrus":["Sunflower Gold","Ochre","Sand"],"daffodil":["Sunflower Gold","Ochre","Creme"],
    "limoncello":["Sunflower Gold","Ochre","Sand"],"nectar":["Ochre","Sunflower Gold","Sand"],    "orange":["Orange","Toboggan","Ochre"],"tangerine":["Orange","Toboggan","Sunflower Gold"],
    "papaya":["Orange","Toboggan","Ochre"],"mandarin":["Orange","Toboggan","Sunflower Gold"],
    "mango":["Orange","Ochre","Sunflower Gold"],"paprika":["Toboggan","Orange","Red"],
    "cayenne":["Red","Toboggan","Orange"],"terracotta":["Toboggan","Saddle","Orange"],
    "terra cotta":["Toboggan","Saddle","Orange"],"rust":["Toboggan","Saddle","Orange"],
    "cinnamon":["Saddle","Brown","Toboggan"],"spice":["Saddle","Toboggan","Brown"],
    "ginger":["Ochre","Saddle","Toboggan"],"gingersnap":["Ochre","Saddle","Toboggan"],
    "pumpkin":["Orange","Toboggan","Ochre"],"persimmon":["Orange","Toboggan","Red"],
    "allspice":["Brown","Saddle","Nutmeg"],"blaze":["Red","Orange","Toboggan"],
    "flame":["Red","Orange","Toboggan"],"molten":["Orange","Red","Toboggan"],
    "red":["Red","Burgundy","Black Cherry"],"cherry":["Red","Burgundy","Black Cherry"],
    "crimson":["Red","Burgundy","Black"],"ruby":["Red","Burgundy","Black Cherry"],
    "cardinal":["Red","Burgundy","Black Cherry"],"valentine":["Red","Burgundy","Black Cherry"],
    "sangria":["Burgundy","Red","Black Cherry"],"tomato":["Red","Burgundy","Black Cherry"],
    "salsa":["Red","Burgundy","Black Cherry"],"hibiscus":["Red","Burgundy","Magma"],
    "cranberry":["Burgundy","Red","Black Cherry"],"raspberry":["Burgundy","Red","Black Cherry"],
    "berry":["Burgundy","Red","Black Cherry"],"wine":["Burgundy","Black Cherry","Red"],
    "burgundy":["Burgundy","Black Cherry","Red"],"bordeaux":["Burgundy","Black Cherry","Red"],
    "claret":["Burgundy","Black Cherry","Red"],"merlot":["Burgundy","Black Cherry","Red"],
    "port":["Burgundy","Black Cherry","Red"],"oxblood":["Burgundy","Black Cherry","Black"],
    "maroon":["Burgundy","Black Cherry","Red"],"pomegranate":["Red","Burgundy","Black Cherry"],
    "american beauty":["Burgundy","Red","Black Cherry"],"rouge":["Red","Burgundy","Black Cherry"],
    "pink":["Red","Creme","Nat. White"],"rose":["Red","Burgundy","Sand"],
    "mauve":["Burgundy","Storm Grey","Pearl Grey"],"magenta":["Red","Burgundy","Magma"],
    "brown":["Brown","Saddle","Nutmeg"],"dark brown":["Brown","Bay Brown","Black"],
    "chocolate":["Brown","Bay Brown","Black"],"coffee":["Brown","Bay Brown","Saddle"],
    "espresso":["Brown","Bay Brown","Black"],"mocha":["Brown","Saddle","Nutmeg"],
    "mocca":["Brown","Saddle","Nutmeg"],"cognac":["Saddle","Brown","Nutmeg"],
    "chestnut":["Brown","Saddle","Nutmeg"],"saddle":["Saddle","Brown","Nutmeg"],
    "nutmeg":["Nutmeg","Brown","Saddle"],"truffle":["Saddle","Brown","Nutmeg"],
    "java":["Brown","Bay Brown","Black"],"tobacco":["Brown","Saddle","Olive Brown"],
    "toffee":["Saddle","Brown","Ochre"],"beaver":["Saddle","Brown","Nutmeg"],
    "walnut":["Brown","Bay Brown","Saddle"],"bark":["Brown","Bay Brown","Black"],
    "sable":["Brown","Saddle","Bay Brown"],"bay brown":["Bay Brown","Brown","Black"],
    "mahogany":["Brown","Bay Brown","Burgundy"],"sienna":["Saddle","Brown","Toboggan"],
    "cordovan":["Brown","Bay Brown","Burgundy"],"fudge":["Brown","Bay Brown","Black"],
    "maple":["Saddle","Brown","Ochre"],"teak":["Saddle","Brown","Sandstone"],
    "oak":["Saddle","Brown","Sand"],"buckskin":["Sandstone","Saddle","Sand"],
    "luggage":["Saddle","Brown","Ochre"],"british tan":["Saddle","Sand","Sandstone"],
    "wicker":["Sand","Saddle","Sandstone"],"bamboo":["Sand","Sandstone","Olive Brown"],
    "driftwood":["Sandstone","Saddle","Sand"],"brandy":["Saddle","Brown","Ochre"],
    "cappuccino":["Brown","Saddle","Sand"],"caramel":["Saddle","Sand","Ochre"],
    "mushroom":["Sand","Sandstone","Storm Grey"],"ale":["Saddle","Brown","Ochre"],
    "chamois":["Sand","Sandstone","Saddle"],"bronze":["Saddle","Brown","Olive Brown"],
    "mudslide":["Brown","Saddle","Sandstone"],"cocoa":["Brown","Saddle","Nutmeg"],    "grey":["Charcoal","Storm Grey","Shark Grey"],"gray":["Charcoal","Storm Grey","Shark Grey"],
    "lt. grey":["Pearl Grey","Storm Grey","Charcoal"],"lt. gray":["Pearl Grey","Storm Grey","Charcoal"],
    "lt grey":["Pearl Grey","Storm Grey","Charcoal"],"med grey":["Storm Grey","Charcoal","Shark Grey"],
    "med. grey":["Storm Grey","Charcoal","Shark Grey"],"pearl grey":["Pearl Grey","Nat. White","Cloudy Sky"],
    "dove":["Pearl Grey","Storm Grey","Charcoal"],"dove grey":["Pearl Grey","Storm Grey","Charcoal"],
    "ash":["Storm Grey","Charcoal","Pearl Grey"],"silver":["Pearl Grey","Storm Grey","Cloudy Sky"],
    "sterling":["Pearl Grey","Storm Grey","Cloudy Sky"],"platinum":["Pearl Grey","Storm Grey","Cloudy Sky"],
    "steel":["Storm Grey","Charcoal","Shark Grey"],"steel gray":["Storm Grey","Charcoal","Shark Grey"],
    "gunmetal":["Charcoal","Shark Grey","Black"],"charcoal":["Black","Charcoal","Graphite"],
    "graphite":["Black","Graphite","Charcoal"],"carbon":["Black","Graphite","Charcoal"],
    "pebble":["Storm Grey","Charcoal","Sandstone"],"stone":["Storm Grey","Charcoal","Sand"],
    "dolphin":["Storm Grey","Pearl Grey","Nat. White"],"flint":["Charcoal","Storm Grey","Black"],
    "haze":["Pearl Grey","Storm Grey","Nat. White"],"fog":["Pearl Grey","Cloudy Sky","Storm Grey"],
    "storm":["Storm Grey","Charcoal","Black"],"warm grey":["Storm Grey","Sandstone","Pearl Grey"],
    "cool gray":["Pearl Grey","Storm Grey","Charcoal"],"slate":["Charcoal","Graphite","Storm Grey"],
    "leadfoot":["Charcoal","Graphite","Black"],"pewter":["Storm Grey","Charcoal","Pearl Grey"],
    "shark grey":["Shark Grey","Charcoal","Storm Grey"],"granite":["Charcoal","Storm Grey","Black"],
    "gravel":["Storm Grey","Charcoal","Sand"],"concrete":["Storm Grey","Charcoal","Pearl Grey"],
    "meteor":["Charcoal","Graphite","Storm Grey"],"shale":["Storm Grey","Charcoal","Sandstone"],
    "greige":["Storm Grey","Sandstone","Pearl Grey"],"elephant":["Storm Grey","Charcoal","Graphite"],
    "dark pewter":["Charcoal","Graphite","Black"],"greystone":["Storm Grey","Charcoal","Pearl Grey"],
    "sharkskin":["Shark Grey","Charcoal","Storm Grey"],"aluminum":["Pearl Grey","Storm Grey","Charcoal"],
    "silver screen":["Pearl Grey","Storm Grey","Cloudy Sky"],"iron":["Black","Graphite","Storm Grey"],
    "quicksilver":["Pearl Grey","Storm Grey","Nat. White"],"ninja":["Black","Graphite","Charcoal"],
    "mineral":["Storm Grey","Charcoal","Sand"],"flannel":["Storm Grey","Charcoal","Pearl Grey"],
    "periscope":["Charcoal","Storm Grey","Black"],"convoy":["Charcoal","Storm Grey","Graphite"],
    "black":["Black","Graphite","Charcoal"],"blackbeard":["Black","Graphite","Charcoal"],
    "ebony":["Black","Graphite","Charcoal"],"ink":["Black","Graphite","Navy"],
    "midnight":["Black","Navy","Graphite"],"raven":["Black","Graphite","Charcoal"],
    "jet":["Black","Graphite","Charcoal"],"coal":["Black","Graphite","Charcoal"],
    "licorice":["Black","Graphite","Charcoal"],"nocturnal":["Black","Graphite","Charcoal"],
    "nightfall":["Black","Graphite","Charcoal"],"nightshade":["Black","Graphite","Charcoal"],
    "blue":["Navy","Marine Blue","Pacific Blue"],"navy":["Navy","Marine Blue","Black"],
    "navy blue":["Navy","Marine Blue","Black"],"marine blue":["Marine Blue","Navy","Pacific Blue"],
    "pacific blue":["Pacific Blue","Mediterranean","Navy"],"royal":["Royal Blue","Navy","Pacific Blue"],
    "royal blue":["Royal Blue","Navy","Pacific Blue"],"celestial":["Pacific Blue","Royal Blue","Navy"],
    "capri":["Pacific Blue","Mediterranean","Navy"],"mermaid":["Pacific Blue","Mediterranean","Navy"],
    "turquoise":["Pacific Blue","Mediterranean","Nat. White"],"turqua":["Pacific Blue","Mediterranean","Nat. White"],
    "teal":["Pacific Blue","Mediterranean","Forest Green"],"jewel":["Royal Blue","Navy","Pacific Blue"],
    "baby blue":["Pacific Blue","Cloudy Sky","Nat. White"],"true blue":["Pacific Blue","Royal Blue","Navy"],
    "artic sky":["Pacific Blue","Cloudy Sky","Nat. White"],"aqua marine":["Pacific Blue","Mediterranean","Navy"],
    "sapphire":["Royal Blue","Navy","Pacific Blue"],"imperial":["Royal Blue","Navy","Pacific Blue"],
    "admiral":["Navy","Marine Blue","Black"],"regatta":["Pacific Blue","Royal Blue","Navy"],
    "atlantic":["Navy","Marine Blue","Pacific Blue"],"mediterranean":["Mediterranean","Pacific Blue","Navy"],
    "lagoon":["Pacific Blue","Mediterranean","Forest Green"],"ocean":["Navy","Pacific Blue","Mediterranean"],
    "cerulean":["Pacific Blue","Royal Blue","Navy"],"neptune":["Pacific Blue","Mediterranean","Navy"],
    "indigo":["Navy","Royal Blue","Black"],"chambray":["Pacific Blue","Storm Grey","Navy"],
    "wedgewood":["Pacific Blue","Storm Grey","Navy"],"sailor":["Navy","Marine Blue","Pacific Blue"],
    "captain":["Navy","Marine Blue","Pacific Blue"],"cascade":["Pacific Blue","Mediterranean","Navy"],
    "seafoam":["Pacific Blue","Nat. White","Pearl Grey"],"surf":["Pacific Blue","Mediterranean","Nat. White"],
    "cove":["Pacific Blue","Navy","Mediterranean"],"scuba":["Pacific Blue","Mediterranean","Navy"],
    "triton":["Pacific Blue","Mediterranean","Navy"],"vivid sky":["Pacific Blue","Cloudy Sky","Nat. White"],
    "tidal wave":["Pacific Blue","Mediterranean","Navy"],"pontus":["Pacific Blue","Mediterranean","Navy"],
    "green":["Forest Green","Seagrass Green","Dark Olive"],"dark green":["Forest Green","Dark Olive","Black"],
    "forest":["Forest Green","Dark Olive","Black"],"forest green":["Forest Green","Dark Olive","Black"],
    "evergreen":["Forest Green","Dark Olive","Black"],"everglade":["Forest Green","Seagrass Green","Dark Olive"],
    "hunter":["Forest Green","Dark Olive","Black"],"kiwi":["Forest Green","Seagrass Green","Dark Olive"],
    "lime":["Forest Green","Seagrass Green","Sand"],"emerald":["Forest Green","Seagrass Green","Dark Olive"],
    "sage":["Seagrass Green","Dark Olive","Sand"],"olive":["Dark Olive","Olive Brown","Seagrass Green"],
    "dark olive":["Dark Olive","Olive Brown","Black"],"fern":["Seagrass Green","Forest Green","Dark Olive"],
    "spruce":["Forest Green","Dark Olive","Black"],"cypress":["Forest Green","Dark Olive","Black"],
    "basil":["Forest Green","Dark Olive","Seagrass Green"],"meadow":["Seagrass Green","Forest Green","Sand"],
    "mint":["Seagrass Green","Nat. White","Pearl Grey"],"celery":["Seagrass Green","Sand","Nat. White"],
    "jade":["Forest Green","Seagrass Green","Pacific Blue"],"peacock":["Forest Green","Pacific Blue","Dark Olive"],
    "grassland":["Seagrass Green","Forest Green","Dark Olive"],"verde":["Forest Green","Seagrass Green","Dark Olive"],
    "wasabi":["Seagrass Green","Sand","Nat. White"],"cucumber":["Seagrass Green","Forest Green","Dark Olive"],
    "mallard":["Forest Green","Pacific Blue","Dark Olive"],"bottle":["Forest Green","Dark Olive","Black"],
    "palm":["Forest Green","Dark Olive","Seagrass Green"],
    "purple":["Navy","Burgundy","Black"],"violet":["Navy","Burgundy","Black"],
    "plum":["Burgundy","Navy","Black"],"eggplant":["Burgundy","Black","Navy"],
    "aubergine":["Burgundy","Black","Navy"],"grape":["Navy","Burgundy","Black"],
    "mulberry":["Burgundy","Navy","Black"],"blackberry":["Black","Burgundy","Navy"],
    "crocus":["Navy","Burgundy","Pearl Grey"],"verbena":["Burgundy","Navy","Pearl Grey"],
    "phoenix":["Orange","Red","Ochre"],"flora":["Seagrass Green","Forest Green","Sand"],
    "cosmic":["Navy","Graphite","Charcoal"],"harmony":["Storm Grey","Sand","Pearl Grey"],
    "clay":["Sandstone","Sand","Saddle"],"limestone":["Sand","Pearl Grey","Storm Grey"],
    "mink":["Brown","Saddle","Storm Grey"],"stardust":["Pearl Grey","Sand","Cloudy Sky"],
    "autumn":["Saddle","Ochre","Toboggan"],"harvest":["Ochre","Sand","Sandstone"],
    "doe":["Sandstone","Sand","Saddle"],"fawn":["Sand","Sandstone","Saddle"],
    "birch":["Sand","Creme","Nat. White"],"hideaway":["Sandstone","Sand","Saddle"],
    "tumbleweed":["Sand","Sandstone","Olive Brown"],"twine":["Sand","Sandstone","Olive Brown"],
    "gull":["Pearl Grey","Storm Grey","Nat. White"],"mirage":["Sand","Storm Grey","Sandstone"],
    "falcon":["Charcoal","Storm Grey","Brown"],"nomad":["Sandstone","Sand","Saddle"],
    "passion":["Red","Burgundy","Magma"],"dusk":["Navy","Charcoal","Storm Grey"],
    "reef":["Pacific Blue","Seagrass Green","Mediterranean"],
    "paradise":["Pacific Blue","Seagrass Green","Mediterranean"],
    "melody":["Burgundy","Navy","Storm Grey"],"red dawn":["Red","Toboggan","Orange"],
    "zest":["Sunflower Gold","Orange","Ochre"],"sassafras":["Brown","Saddle","Ochre"],
    "old bourbon":["Saddle","Brown","Ochre"]
  };
  var HEX = {
    "Nat. White":"#F5F0E8","Creme":"#EDE0C4","Sunflower Gold":"#F0B429","Ochre":"#C8922A",
    "Orange":"#D4621A","Toboggan":"#B5451B","Magma":"#C0392B","Red":"#CC1111",
    "Burgundy":"#6B1A2A","Black Cherry":"#3D0C14","Pacific Blue":"#2E86C1",
    "Mediterranean":"#1A5276","Royal Blue":"#1A3C8B","Marine Blue":"#1B3A5C",
    "Navy":"#0D1B3E","Forest Green":"#1E5C2A","Seagrass Green":"#4A7C3A",
    "Dark Olive":"#3D4A1A","Sand":"#D4BA8A","Sandstone":"#C4A878",
    "Olive Brown":"#7A6A2A","Beaver":"#8B7355","Saddle":"#8B4513","Nutmeg":"#6B3A2A",
    "Brown":"#5C2E0E","Bay Brown":"#4A1E0A","Storm Grey":"#7A8A9A","Cloudy Sky":"#B0BEC5",
    "Pearl Grey":"#CFD8DC","Shark Grey":"#607D8B","Charcoal":"#37474F","Med. Steel":"#546E7A",
    "Graphite":"#263238","Black":"#1A1A1A"
  };
  var LIGHT = ["Nat. White","Creme","Pearl Grey","Cloudy Sky","Sand","Sandstone"];

  function stripPrefix(name) {
    var m = name.match(/^[A-Za-z]{2,5}\s+\d{2,5}\s+(.+)$/);
    if (m) return m[1].trim();
    var m2 = name.match(/^[A-Za-z]{2,4}\s+([A-Z][a-z].*)$/);
    if (m2) return m2[1].trim();
    return name;
  }

  function getSuggestions(colorName) {
    if (!colorName) return [];
    var stripped = stripPrefix(colorName);
    var lo = stripped.toLowerCase().trim();
    if (MAP[lo]) return MAP[lo];
    var keys = Object.keys(MAP);
    for (var i = 0; i < keys.length; i++) {
      if (lo.indexOf(keys[i]) !== -1 || keys[i].indexOf(lo) !== -1) return MAP[keys[i]];
    }
    var words = lo.split(/\s+/);
    for (var w = words.length - 1; w >= 0; w--) {
      if (words[w].length < 3) continue;
      if (MAP[words[w]]) return MAP[words[w]];
      for (var j = 0; j < keys.length; j++) {
        if (words[w] === keys[j] || (words[w].length > 3 && keys[j].indexOf(words[w]) !== -1)) return MAP[keys[j]];
      }
    }
    return ["Black","Nat. White","Charcoal"];
  }

  function showThreadMatch(colorName) {
    var box = document.getElementById('thread-match-box');
    var swatchWrap = document.getElementById('thread-match-swatches');
    if (!box || !swatchWrap) return;
    var names = getSuggestions(colorName);
    swatchWrap.innerHTML = names.map(function(n) {
      var h = HEX[n] || '#888';
      var border = LIGHT.indexOf(n) !== -1 ? 'border:1px solid #555;' : '';
      return '<a href="/products/amann-outdoorpro-thread-tex-135-1-lb-spool" title="' + n + ' thread" style="display:flex;flex-direction:column;align-items:center;gap:4px;text-decoration:none;">'
        + '<span style="display:block;width:28px;height:28px;border-radius:50%;background:' + h + ';' + border + 'box-shadow:inset 0 1px 3px rgba(0,0,0,0.3);"></span>'
        + '<span style="font-size:0.6rem;color:#A09890;text-align:center;white-space:nowrap;">' + n + '</span>'
        + '</a>';
    }).join('');
    box.style.display = 'block';
  }

  document.addEventListener('DOMContentLoaded', function() {
    var box = document.getElementById('thread-match-box');
    if (!box) return;
    document.querySelectorAll('.product-option__values label').forEach(function(label) {
      label.addEventListener('click', function() {
        var radio = label.querySelector('input[type="radio"]');
        if (radio && radio.closest('[data-option-name="color"]')) {
          var colorVal = radio.value.replace(/\s*\([^)]+\)$/, '').trim();
          showThreadMatch(colorVal);
        }
      });
    });
    var defaultColor = document.querySelector('[data-option-name="color"] input[type="radio"]:checked');
    if (defaultColor) {
      showThreadMatch(defaultColor.value.replace(/\s*\([^)]+\)$/, '').trim());
    }
  });
})();
